import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateTransacitonStatus } from 'app/dtos/Transaction/updateTransactionStatus';
import { _isId } from 'app/services/auth.service';
import { CompanyService } from 'app/services/models/company.service';
import { KindService } from 'app/services/models/kind.service';
import { ProjectService } from 'app/services/models/project.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { VaultService } from 'app/services/models/vault.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-vault-company-movement',
  templateUrl: './create-vault-company-movement.component.html',
  styleUrls: ['./create-vault-company-movement.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class CreateVaultCompanyMovementComponent implements OnInit {
  @Input() data: { companyId?: number, transactionId: number, price: number, vaultKind?: number, totalPrice?: number, companyNetBalance?: number, projectId?: number };
  vaultForm: FormGroup;
  kinds: any[] = [];
  vaults: any[] = [];
  companies: any[] = [];
  projects: any[] = [];
  
  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private vaultService: VaultService,
    private companyService: CompanyService,
    private toastrService: ToastrService,
    private projectService: ProjectService,
    private transactionService: TransactionService
  ) {

  }

  async ngOnInit() {
    this.vaultForm = this.fb.group({
      balance: ['', Validators.required],
      description: [''],
      kind: [null, Validators.required],
      vault: [null, Validators.required],
      company: [null, Validators.required],
      projectId: [null],
      companyNetBalance: [null],
      vaultDate: [null]
    });
    await this.getAllKinds();
    await this.getAllVaults();
    await this.getAllCompanies();
    await this.getAllProjects();

    console.log(this.data);
    // Formu yeniden değerlendirin
    if (this.data.companyId) {
      await this.companyByIdBalance(this.data.companyId);
    }
    this.vaultForm.patchValue({
      company: Number(this.data.companyId),
      balance: this.data.price,
      kind: Number(this.data.vaultKind),
      companyNetBalance: this.data.companyNetBalance,
      projectId: this.data.projectId ?? null
    })
  }

  async save() {
    if (this.vaultForm.invalid) {
      // Form geçerli değilse, hataları göster
      this.vaultForm.markAllAsTouched();
      return;
    }


    const data = await this.vaultService.createCompanyVaultMovement(
      this.vaultForm.value.vault,
      this.vaultForm.value.balance,
      this.vaultForm.value.kind,
      _isId,
      this.vaultForm.value.company,
      this.vaultForm.value.description,
      this.vaultForm.value.projectId,
      this.data.transactionId ? this.data.transactionId : null,
      this.vaultForm.value.valutDate
    );
    if (data.status == true) {
      this.vaultService.sendEvent(true);
      this.companyService.sendEvent(true);
      this.transactionService.sendEvent(true)
      this.toastrService.success(data.message);
    } else {
      this.toastrService.error(data.message);
    }

    this.activeModal.close(true);
  }

  async companyByIdBalance(id) {
    const data = await this.companyService.getByIdCompanyBalance(id);
    this.data.companyNetBalance = data;
  }

  async getAllProjects() {
    const data = await this.projectService.getAllProject(0, 100, '');
    console.log(data);
    this.projects = data.projects;
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 50, 8);
    console.log(data);
    this.kinds = data.types.filter(p => p.typeName != "Transfer");
  }

  async getAllVaults() {
    const data = await this.vaultService.getAllVault(0, 50, '');
    console.log(data);
    this.vaults = data.vaults;
    if (this.vaults?.length == 1) {
      this.vaultForm.patchValue({
        vault: this.vaults[0]?.id
      })
    }
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 10000);
    console.log(data);
    this.companies = data.companies;
  }

  closeModal() {
    this.activeModal.close(false);
  }
}
